import { usePunditUserContext } from "@circle-react/contexts";

export const useIsSystemTemplatesEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(
    currentCommunitySettings?.create_system_marketing_email_templates_enabled,
  );
};
